import React from 'react';
import { useSelector } from 'react-redux';
import { DropdownNavigation } from '../../../global/components/dropdown-navigation';
import { GenerateClergyBioQuickNavMenu } from '../../../global/constants/navigation-lists';
import { TcsmSiteSettingsProps } from '../../../global/models/epi-model';
import { TcsmStates } from '../../../root/tcsm-model';


export interface Props {
	basePath: string;
}

export const ClergyBioNav = (props: Props) => {

	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const navOptions = GenerateClergyBioQuickNavMenu(props.basePath, language, siteSettings);

	return (
		<DropdownNavigation options={navOptions} />
	);
};